export default __webpack_public_path__ + "static/media/cross.052a739e.svg";